module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return _h('div', {
    attrs: {
      "id": "app"
    }
  }, [_h('site-header'), " ", _h('div', {
    attrs: {
      "id": "route-container"
    }
  }, [_h('transition', {
    attrs: {
      "name": "shrink",
      "mode": "in-out"
    }
  }, [_h('router-view')])]), " ", _h('site-footer')])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b82d32f2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 54
// module chunks = 1